import axios from "axios";

export async function ApplyProfileBase(id) {
  const token = btoa(
    `${process.env.REACT_APP_USERNAME}:${process.env.REACT_APP_PASSWORD}`
  );
  const body = {
    udid: id,
    request_type: "InstallProfile",
    payload: process.env.REACT_APP_PAYLOAD_PROFILE_GENERAL,
  };
  try {
    const response = await axios.post(
      process.env.REACT_APP_API_URL + "/commands",
      body,
      {
        headers: {
          Authorization: `Basic ${token}`,
        },
      }
    );
    console.log("✅ Respuesta del servidor:", response.data);
    return response.data;
  } catch (err) {
    console.error("❌ Error general:", err);
    return [];
  }
}

export function RemoveProfileBase(uuid) {
  const token = btoa(
    `${process.env.REACT_APP_USERNAME}:${process.env.REACT_APP_PASSWORD}`
  );
  try {
    axios.post(
      process.env.REACT_APP_API_URL + "/commands",
      {
        udid: uuid,
        request_type: "RemoveProfile",
        identifier: "MICRO-2.B415BCA0-A1C7-4CA4-9251-9FD9A70E2C83",
      },
      {
        headers: {
          Authorization: `Basic ${token}`,
        },
      }
    );
  } catch (err) {
    console.error("❌ Error general:", err);
    return [];
  }
}

export function RemoveProfileRestric(uuid) {
  const token = btoa(
    `${process.env.REACT_APP_USERNAME}:${process.env.REACT_APP_PASSWORD}`
  );
  try {
    axios.post(
      process.env.REACT_APP_API_URL + "/commands",
      {
        udid: uuid,
        request_type: "RemoveProfile",
        identifier: "CREDITEST-2.C9C8EC9A-8C48-4404-AE46-8B70D1831032",
      },
      {
        headers: {
          Authorization: `Basic ${token}`,
        },
      }
    );
  } catch (err) {
    console.error("❌ Error general:", err);
    return [];
  }
}

export function ApplyProfileRestrict(id) {
  const token = btoa(
    `${process.env.REACT_APP_USERNAME}:${process.env.REACT_APP_PASSWORD}`
  );
  const body = {
    udid: id,
    request_type: "InstallProfile",
    payload: process.env.REACT_APP_PAYLOAD_PROFILE_RESTRICT,
  };

  try {
    axios.post(process.env.REACT_APP_API_URL + "/commands", body, {
      headers: {
        Authorization: `Basic ${token}`,
      },
    });
  } catch (err) {
    console.error("❌ Error general:", err);
    return [];
  }
}

export async function ApplyModeLost(id) {
  const token = btoa(
    `${process.env.REACT_APP_USERNAME}:${process.env.REACT_APP_PASSWORD}`
  );
  const body = {
    udid: id,
    request_type: "EnableLostMode",
    message: "help! I'm lost!",
    phone_number: "123456789",
    footnote: "help! I'm lost!",
  };
  try {
    const response = await axios.post(
      process.env.REACT_APP_API_URL + "/commands",
      body,
      {
        headers: {
          Authorization: `Basic ${token}`,
        },
      }
    );
    console.log("✅ Respuesta del servidor:", response.data);
    return response.data;
  } catch (err) {
    console.error("❌ Error general:", err);
    return [];
  }
}

export async function RemoveModeLost(id) {
  const token = btoa(
    `${process.env.REACT_APP_USERNAME}:${process.env.REACT_APP_PASSWORD}`
  );
  const body = {
    udid: id,
    request_type: "DisableLostMode",
  };
  try {
    const response = await axios.post(
      process.env.REACT_APP_API_URL + "/commands",
      body,
      {
        headers: {
          Authorization: `Basic ${token}`,
        },
      }
    );
    console.log("✅ Respuesta del servidor:", response.data);
    return response.data;
  } catch (err) {
    console.error("❌ Error general:", err);
    return [];
  }
}
